define('utils/common', [
    'utils/dom',
    'tabTrace',
    'utils/AnimateProcessor',
    'utils/service',
    'utils/tools',
    'utils/toast',
    'jquery',
    'cookie',
    'escroll'
], function (dom, tabTrace, AnimateProcessor, service, tools, toast, $, cookie, Escroll) {
    'use strict';

    var createMaskFadeOutFn = function (maskStyke, modalStyle) {
        var fadeOutProcessor = new AnimateProcessor(600)

        return function () {
            fadeOutProcessor.excuteAnimaFrame(function (percentage) {
                var value = 1 - this.getIncByTimeFn('ease-in-out', percentage)
                maskStyke.opacity = value
                modalStyle.opacity = value
                return percentage < 1
            }, function () {
                maskStyke.display = 'none'
                maskStyke.opacity = ''
                modalStyle.display = 'none'
                modalStyle.opacity = ''
            })
        }
    }

    var createGetCodeFn = function (input, emitter) {
        var isSending = false;
        var getCuntDownText = function (s) {
            return '已发送' + ('0' + s).slice(-2) + 's'
        }

        return function () {
            var phoneNum = input.value

            if (phoneNum == '') {
                return toast.show('手机号不能为空');
            }

            if (isSending) {
                return console.warn('请勿重复点击');
            }

            isSending = true

            service.getCode(phoneNum).then(function (res) {
                if (res) {
                    toast.show('发送成功')
                    var t = 60,
                        c;
                    emitter.innerText = getCuntDownText(t)
                    c = setInterval(function () {
                        t--;
                        emitter.innerText = getCuntDownText(t)
                        if (t === 0) {
                            t = 60
                            isSending = false
                            emitter.innerText = '发送验证码'
                            clearInterval(c)
                        }
                    }, 1000);
                } else {
                    isSending = false
                }
            })
        };
    }

    var comPopupHydrate = function (emitterId, type, extras) {
        var popUpId = '#' + type + 'Popup'
        var closeBtnId = '#' + type + 'BtnClose'

        var popShowFn = function () {
            $('.com-mask').show()
            $(popUpId).show()
        }

        $(emitterId).click(popShowFn)

        if (extras && extras.length > 0) {
            var i = extras.length
            var el
            while (i--) {
                el = extras[i]
                $(el).click(popShowFn)
            }
        }

        var rawMask = $('.com-mask')[0]
        var rawPopup = $(popUpId)[0]
        var rawBtn = $(closeBtnId)[0]

        var popHideFn = createMaskFadeOutFn(rawMask.style, rawPopup.style)

        rawMask.addEventListener('click', popHideFn)
        rawBtn.addEventListener('click', popHideFn)
    }


    var userFormHydrate = function () {
        var phone = $('#userPhone')[0]
        var code = $('#userCode')[0]
        var pwd = $('#userPwd')[0]
        var pwd$ = $('#userConfirmPwd')[0]

        //获取验证码
        var userGetCodeFn = createGetCodeFn(phone, $('#sendUserCode')[0])
        $('#sendUserCode').click(userGetCodeFn)

        //提交表单
        $('#userConfirm').click(function () {
            if (!tools.checkForm([phone, code, pwd, pwd$])) {
                return toast.show('请填写完整信息');
            }

            var regex = /^\S{6,20}$/;

            if (!regex.test(pwd.value)) {
                return toast.show('请设置6-20位密码!');
            }

            if (pwd.value !== pwd$.value) {
                return toast.show('两次输入的密码不一致');
            }

            service.updatePwd(pwd.value, phone.value, code.value).then(function (res) {
                if (res) {
                    toast.show('修改成功');
                    tools.clearForm([phone, code, pwd, pwd$]);
                    setTimeout(function () {
                        window.location.reload()
                    }, 1000)
                }
            })
        })
    }


    var updatePhoneFormHydrate = function () {
        var phone = $('#updatePhone')[0]
        var code = $('#updatePhoneCode')[0]

        //获取验证码
        var getCodeFn = createGetCodeFn(phone, $('#sendUpdatePhoneCode')[0])
        $('#sendUpdatePhoneCode').click(getCodeFn)

        //提交表单
        $('#updatePhoneSubmit').click(function () {
            if (!tools.checkForm([phone, code])) {
                return toast.show('请填写完整信息');
            }

            service.updatePhone(phone.value, code.value).then(function (res) {
                if (res) {
                    toast.show('修改成功');
                    tools.clearForm([phone, code]);
                    setTimeout(function () {
                        window.location.reload()
                    }, 1000)
                }
            })
        })
    }





    return {
        renderTabTrace: function () {
            /**
             * 头部导航底部动画
             */
            var headerActiveNavs = document.querySelectorAll(".header-nav-a[data-header-nav-active-index]")
            var i
            if ((i = headerActiveNavs.length)) {
                var currActiveNavIndex;
                var nav
                while (i--) {
                    nav = headerActiveNavs[i]
                    if (dom.getData(nav, 'header-nav-active-index') === '1') {
                        currActiveNavIndex = i
                    }
                }
                if (currActiveNavIndex !== void 0) {
                    tabTrace(".header-nav-a", "horizontal", {
                        eventType: "mouse",
                        bgColor: "#63B504",
                        transitionTimeFun: "ease",
                        transitionDuration: ".4s",
                        activeItemStyle: {
                            fontWeight: "bolder",
                            color: '#63B504'
                        },
                        borderRadius: "0vw",
                        activeIndex: currActiveNavIndex,
                        height: '4px'
                    });
                }
            }
        },
        /**
         * 为固定弹窗注入事件
         */
        popupHydrate: function () {
            //联系我弹窗交互
            var btnMore = document.querySelector('.btn-know-more')
            var btnService = document.querySelector('#btnService')
            var btnGroup = document.querySelector('#btnGroup')

            var array = []

            if (btnMore) {
                array.push(btnMore)
            }

            if (btnService) {
                array.push(btnService)
            }

            if (btnGroup) {
                array.push(btnGroup)
            }

            comPopupHydrate('#appDefine', 'need', array)
        },
        checkUser: function () {
            var logined = document.querySelector('#logined')
            var noLogin = document.querySelector('#noLogin')

            if (logined && noLogin) {
                service.getUserCookie().then((function (res) {
                    if (res && res._Account) {
                        dom.addClass(noLogin, 'hidden')
                        dom.removeClass(logined, 'hidden')

                        $("#userloginid").html(res._Account.LoginId);

                        if (res.Agentinfo != null && res.Agentinfo.userLevel == 0) {
                            $("#agentauthod").html(res.Agentinfo.AuthCode);
                            $("#showagent").show();
                        }

                        if (res._Account.ConsigneePhone == null || res._Account.ConsigneePhone.length <= 0) {
                            $("#updatephone").html("绑定");
                        } else {
                            $("#updatephone").html("修改");
                            $("#userphone").html(res._Account.ConsigneePhone);
                        }

                        comPopupHydrate('#updateuser', 'user')
                        comPopupHydrate('#updatephone', 'phone')
                        userFormHydrate()
                        updatePhoneFormHydrate()
                    } else {
                        dom.addClass(logined, 'hidden')
                        dom.removeClass(noLogin, 'hidden')
                    }
                }))
            }
        },
        submitForm: function (els, formKeys) {
            if (!tools.checkForm(els)) {
                return toast.show('请填写完整信息')
            }

            toast.showLoading('提交中')

            var formKeys = formKeys || ['username', 'Phone', 'desc', 'source']
            var temp = {}

            var i = els.length
            var value, formKey;
            while (i--) {
                value = els[i].value
                formKey = formKeys[i]
                temp[formKey] = value
            }

            var isTimeout = true

            service.submitForm(temp).then(function (res) {
                isTimeout = false
                if (res) {
                    toast.hideLoading()
                    toast.show('我们已收到您的请求，小未专员会尽快联系您！', 1500)
                    tools.clearForm(els)
                }
            })

            setTimeout(function () {
                if (isTimeout) {
                    toast.hideLoading()
                    toast.show('请求超时')
                }
            }, 5000)
        },
        popUpFormHydrate: function () {
            var nameEl = document.querySelector('#globalName')
            var phoneEl = document.querySelector('#globalPhone')
            var needEl = document.querySelector('#globalNeed')
            var btnEl = document.querySelector('#globalSubmit')
            var that = this

            if (nameEl && phoneEl && needEl) {
                var postEls = [nameEl, phoneEl, needEl]

                // 团购页面，加上source 10
                if (window.location.pathname.toLowerCase().indexOf('societygrouping') > -1) {
                    postEls.push({
                        value: 10
                    })
                }

                btnEl.addEventListener('click', function () {
                    that.submitForm(postEls)
                })
            }
        },
        Exit: function () {
            $("#exit").bind("click", function () {
                if (confirm("确定退出当前用户")) {
                    var url = window.location.host;
                    var domain = "";
                    if (url.indexOf("www.") != -1) {
                        domain = url.replace("www.", ".");
                    } else {
                        domain = "." + url;
                    }
                    var useraccountid = $.cookie("agent_UserCookieNew");
                    $.cookie("dz_UserCookieNew", "00000000-0000-0000-0000-000000000000", {
                        expires: 7,
                        path: '/',
                        domain: domain
                    });
                    $.cookie("agent_UserCookieNew", "00000000-0000-0000-0000-000000000000", {
                        expires: 7,
                        path: '/',
                        domain: domain
                    });
                    window.location.href = "/dzhome/logout?userAccountId=" + useraccountid;
                }
            });
        },
        GetSystemMessageList: function () {
            $.post("/dzhome/GetNoReadSystempMessageList", function (data) {
                if (data.isok) {
                    var array = new Array();
                    if (data.data != null && data.data.length > 0) {
                        for (var i = 0; i < data.data.length; i++) {
                            var model = data.data[i];
                            array[array.length] = '<a href="/dzhome/SystemMessageList?sysid=' + model.Id + '"><div class="msg-item"><p class="mb20">' + model.Title + '</p><div class="content c999 webkit-ellipsis line4 lh18">' + model.Content + '</div></div></a>';
                            //显示前两条
                            if (i > 0) {
                                break;
                            }
                        }
                        $("#sysmsg_content").empty().html(array.join(""));
                        $(".allreadclick").show();
                        $("#redpoint").show();
                    }
                }
            })
        },
        AllRead: function () {
            $(".allreadclick").on("click", function () {
                $.post("/dzhome/AllRead", function (data) {
                    if (data.isok) {
                        window.location.reload();
                    }
                })
            })
        },
        baiduChatHydrate: function () {
            var emitterProxys = document.querySelectorAll('.baiduChat')
            var i
            if ((i = emitterProxys.length)) {
                tools.polling('#nb_icon_wrap', function (emitter) {
                    var showChat = function () {
                        emitter.click()
                    }
                    var emitterProxy
                    while (i--) {
                        emitterProxy = emitterProxys[i]
                        emitterProxy.addEventListener('click', showChat)
                    }
                })
            }
        },
        listenWindowScroll: function () {
            var createThrottleFn = function (delay, fn) {
                var startTime = Date.now()
                return function () {
                    var currTime = Date.now()
                    if (currTime - startTime >= delay) {
                        fn()
                        startTime = currTime
                    }
                }
            }

            var $btnTop = $('.nav-goTop-wrap')

            if (!$btnTop) {
                return;
            }

            var scroller = new Escroll()

            $btnTop.click(function () {
                scroller.scrollToTop()
            })

            var handleScroll = createThrottleFn(50, function () {
                var body = document.body
                var html = document.documentElement
                var scrollTop = Math.max(body.scrollTop, html.scrollTop)

                if (scrollTop >= 300) {
                    $btnTop.css('opacity', 1)
                } else {
                    $btnTop.css('opacity', 0)
                }
            })

            $(window).bind('scroll', handleScroll)
        },
        createGetCodeFn$: createGetCodeFn
    }
});
